import { render } from "./SideBarMobile.vue?vue&type=template&id=163fd8ae"
import script from "./SideBarMobile.vue?vue&type=script&lang=js"
export * from "./SideBarMobile.vue?vue&type=script&lang=js"

import "./SideBarMobile.vue?vue&type=style&index=0&id=163fd8ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__